__turbopack_context__.v({
  "component": "style-module-scss-module__MEgF8W__component",
  "faq-content": "style-module-scss-module__MEgF8W__faq-content",
  "faq-cta-buttons": "style-module-scss-module__MEgF8W__faq-cta-buttons",
  "faq-details": "style-module-scss-module__MEgF8W__faq-details",
  "faq-header": "style-module-scss-module__MEgF8W__faq-header",
  "faq-number": "style-module-scss-module__MEgF8W__faq-number",
  "faq-numbered-title": "style-module-scss-module__MEgF8W__faq-numbered-title",
  "faq-title-text": "style-module-scss-module__MEgF8W__faq-title-text",
  "toggle-icon": "style-module-scss-module__MEgF8W__toggle-icon",
});
